import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initUtmCaptureFromUrl } from './utils/utm';
import { hasAnalyticsCookieConsent } from './utils/cookiePreferences';
import {
  getPosthogBootstrapFromUrl,
  stripPosthogPassThroughParamsFromUrl,
} from './utils/posthogCrossDomain';
import posthog from 'posthog-js';

const posthogBootstrap = getPosthogBootstrapFromUrl();

posthog.init(process.env.REACT_APP_POSTHOG_KEY!, {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
  person_profiles: 'identified_only',
  opt_out_capturing_by_default: !hasAnalyticsCookieConsent(),
  ...(posthogBootstrap ? { bootstrap: posthogBootstrap } : {}),
});

stripPosthogPassThroughParamsFromUrl();
initUtmCaptureFromUrl();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
